import Modal from '@/components/Basic/Modal/Modal'
import Step from '@/components/Basic/Modal/Step'
import Header from '@/components/Basic/Modal/Header'
import Content from '@/components/Basic/Modal/Content'
import Footer from '@/components/Basic/Modal/Footer'

export default {
  container: Modal,
  step: Step,
  header: Header,
  content: Content,
  footer: Footer,
}
